<template>
    <div class="group relative">
        <!-- eslint-disable-next-line vue/no-v-html - html is pre-sanitized by parent -->
        <div v-html="html" />
        <button
            type="button"
            class="absolute top-0 right-0 inline-flex items-center gap-1 px-2 py-1 details text-valence-grey-750 bg-transparent border border-[#E8E8E8] rounded-full cursor-pointer transition-[opacity,background-color] duration-150 opacity-0 group-hover:opacity-70 hover:opacity-100 hover:bg-[#F3F3F3] focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-valence-primary-500"
            @click="handleCopy">
            <Copy class="w-3 h-3" />
            {{ isCopied ? "Copied!" : "Copy" }}
        </button>
    </div>
</template>

<script setup lang="ts">
import { useTimedShow } from "~vue/composables/useTimedShow";
import Copy from "~vue/icons/Copy.vue";
import { logUserInteraction } from "~vue/utils/logUtils";
import { inject, onMounted } from "vue";

interface Props {
    content: string;
    html: string;
    blockIndex: number;
    messageId?: number;
}

const props = defineProps<Props>();
const coachingSessionUuid = inject<string>("coachingSessionUuid");
const { show: showCopied, isShowing: isCopied } = useTimedShow({ duration: 2000 });

onMounted(() => {
    logUserInteraction("copyable_block_shown", { chat_message_id: props.messageId, block_index: props.blockIndex }, coachingSessionUuid);
});

const handleCopy = async () => {
    await navigator.clipboard.writeText(props.content);
    showCopied();
    logUserInteraction("copyable_block_copied", { chat_message_id: props.messageId, block_index: props.blockIndex, content_length: props.content.length }, coachingSessionUuid);
};
</script>

<style scoped>
@media (hover: none) {
    button {
        opacity: 1 !important;
    }
}
</style>
